const PatientCSVUploadTypes = {
  BROADCAST: 'PATIENT_BROADCAST_LIST',
  PATIENT: 'PATIENT',
  APPOINTMENT_REMINDERS: 'AUTOMATED_APPOINTMENT_REMINDERS',
} as const;

export default PatientCSVUploadTypes;
